<template>
  <div class="login-panel animate__animated animate__bounceInRight animate__fast">
    <div class="login-title"><h2>后台管理系统</h2></div>
    <div class="login-form-wrap">
      <login-account ref="accountRef"></login-account>

      <div class="account-control">
        <el-checkbox v-model="isKeepPassword" name="type" class="is-keep-password"> 记住密码 </el-checkbox>
        <el-link type="primary">忘记密码</el-link>
      </div>

      <el-button type="primary" class="login-btn" @click="handleLoginClick">立即登录</el-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import LoginAccount from '@/views/login/cpns/login-account.vue'
import { ref } from 'vue'

const accountRef = ref<InstanceType<typeof LoginAccount>>()
const isKeepPassword = ref<boolean>(true)

const handleLoginClick = () => {
  accountRef.value?.loginAction(isKeepPassword.value)
}
</script>

<style scoped lang="less">
.login-panel {
  width: 320px;
  margin-bottom: 50px;

  .login-title {
    text-align: center;
  }
  .login-form-wrap {
    margin-top: 16px;
    padding: 16px;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    background: #fff;
  }
  .login-btn {
    width: 100%;
  }
  .account-control {
    margin-top: 10px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;

    .is-keep-password {
      color: #409eff;
    }
  }
}
</style>
